import { render } from "./modal-add-teachers-to-group.vue?vue&type=template&id=6159b45d&scoped=true"
import script from "./modal-add-teachers-to-group.vue?vue&type=script&lang=js"
export * from "./modal-add-teachers-to-group.vue?vue&type=script&lang=js"

import "./modal-add-teachers-to-group.vue?vue&type=style&index=0&id=6159b45d&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6159b45d"],['__file',"src/components/admin-dashboard/modals/modal-add-teachers-to-group.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6159b45d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6159b45d', __exports__)) {
    api.reload('6159b45d', __exports__)
  }
  
  module.hot.accept("./modal-add-teachers-to-group.vue?vue&type=template&id=6159b45d&scoped=true", () => {
    api.rerender('6159b45d', render)
  })

}


export default __exports__